import { useEffect, useState } from "react";
import api from "@/lib/api";

let cached = null;
let pending = null;

const load = (tries = 3) => api.get("/features").then((r) => r.data).catch((e) => {
  if (tries > 1) return new Promise((res) => setTimeout(res, 1000)).then(() => load(tries - 1));
  throw e;
});

export function useFeatures() {
  const [f, setF] = useState(cached || { phase2: false, loading: true });
  useEffect(() => {
    if (cached) {
      return;
    }
    pending = pending || load();
    pending.then((d) => { cached = d; setF(d); }).catch(() => { pending = null; setF({ phase2: false, loading: false }); });
  }, []);
  return f;
}
